import { blobToBase64, blobUrlToBlob } from 'core/crud/utils';
import React from 'react';
import { useTranslation } from 'react-i18next';

type UseCropImageProps = {
  onChange: (data: string) => void;
  onChangeFile: (file: File | undefined) => void;
  setImage: (data: string) => void;
};

type UseCropImageReturn = {
  file: File | undefined;
  image: string;
  open: boolean;
  isOriginalImage: boolean;
  getFile: (event: File | undefined) => void;
  onCancel: () => void;
  onChangeImage: (data: string) => void;
  onCheckOriginal: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onOpenDialog: (data: File | undefined) => void;
  onSuccess: () => void;
  t: (key: string) => string;
};

function useCropImage({ onChange, onChangeFile, setImage }: UseCropImageProps): UseCropImageReturn {
  const { t } = useTranslation(['actions']);
  const [file, setFile] = React.useState<File | undefined>(undefined);
  const [image, setImageOrigin] = React.useState<string>('');

  const [isOriginalImage, setIsOriginalImage] = React.useState<boolean>(false);
  const [open, setOpen] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (isOriginalImage) {
      blobUrlToBlob(image).then((blob) => {
        blobToBase64(blob).then((base64) => {
          onChange(base64);
          setImage(base64);
        });
      });
    }
  }, [isOriginalImage]);

  function getOriginImage(data: File | undefined): void {
    const newImage = data ? URL.createObjectURL(data) : '';
    setImageOrigin(newImage);
  }

  function onCheckOriginal(event: React.ChangeEvent<HTMLInputElement>): void {
    setIsOriginalImage(event.target.checked);
  }

  function onChangeImage(data: string): void {
    if (open) {
      onChange(data);
      setImage(data);
    }
  }

  function getFile(event: File | undefined): void {
    setFile(event);
    onChangeFile(event);
    getOriginImage(event);

    if (event === undefined) {
      onChange('');
      setImage('');
    }
  }

  function onOpenDialog(data: File | undefined): void {
    if (data) {
      setOpen(true);
    }
  }

  function onSuccess(): void {
    onCloseModal();
  }

  function onCancel(): void {
    onCloseModal();
  }

  function onCloseModal(): void {
    setOpen(false);
    setIsOriginalImage(false);
  }

  return {
    file,
    image,
    open,
    isOriginalImage,
    getFile,
    onCancel,
    onChangeImage,
    onCheckOriginal,
    onOpenDialog,
    onSuccess,
    t,
  };
}

export default useCropImage;
